import { FeatureName } from '@app/core/interfaces/c5/feature-name';
import { FeatureStatus } from '@app/core/interfaces/c5/feature-status';
import { FeatureState } from '@app/utils/feature/feature-state';
import { Feature } from '@business/feature/models/feature-model';

export function checkForFeature(features: Feature[], name: FeatureName): FeatureState {
  const feature = features.find((feature) => feature.featName === name);

  return {
    active: feature?.status === FeatureStatus.ACTIVE,
    exists: feature != null,
  };
}
